import { Organisation } from '../../../types/organisation';
import { OnboardingJourney, PatientCommunicationChannel, WebsiteConfiguration } from '../types/websiteConfiguration';

export const createEmptyConfig = (org: Organisation): WebsiteConfiguration => ({
  deployed: false,
  enabled: false,
  branding: {
    colors: {
      primary: org.branding?.brand_colour?.toLowerCase(),
      secondary: org.branding?.brand_colour_secondary?.toLowerCase(),
    },
    display_powered_by: true,
  },
  onboarding_journey: OnboardingJourney.PHARMACY_SELECT,
  about_us: {
    enabled: false,
  },
  contact_us: {
    enabled: false,
    ...(org.primaryUser && { contact_name: [org.primaryUser.firstName, org.primaryUser.lastName].join(' ') }),
    ...(org.address && { contact_address: [org.address.name, org.address.street, org.address.city, org.address.postcode, org.address.country].filter(Boolean).join(', ') }),
    ...(org.primaryUser?.email && { email: org.primaryUser.email }),
    ...(org.primaryUser?.telephone && { phone_number: org.primaryUser.telephone }),
    display_gphc_logo: false,
  },
  meta: {
    title: `${org.name} | NHS Prescriptions & Pharmacy Services`,
    description: `${org.name} gives you a central point to manage your health, so you can be sure your prescription orders and messages are going directly to your GP and pharmacy - nobody else.`,
    'og:title': `${org.name} | NHS Prescriptions & Pharmacy Services`,
    'og:description': `${org.name} gives you a central point to manage your health, so you can be sure your prescription orders and messages are going directly to your GP and pharmacy - nobody else.`,
  },
  communication_channel: PatientCommunicationChannel.HEALTHERA,
  ...(org.type === 'prescriber' && {
    private_prescriptions_journey: {
      classic_mode_collection: true,
    }
  }),
});
